import React from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import { Typography, Box } from '@mui/material';
import ActionAlert from '../../../../../../components/Alert/ActionAlert.jsx';
import CardMarkerSmall from '../../../../../../components/CockpitCards/CardMarkerSmall.jsx'
import * as c from '../../../../../../constants.jsx';
import TextCardBold from "../../../../../../components/TextComps/TextCardBold.jsx";
import TextCard from "../../../../../../components/TextComps/TextCard.jsx";
import TrafficLightIndicator from "../../../../../../components/TrafficLight/TrafficLightIndicator.jsx";
import InfoButton from "../../../../../../components/Button/InfoButton.jsx";
import Divider from '@mui/material/Divider';
import GetGenus from "./GetGenus.jsx";
import { useTheme } from "@mui/material";
import ButtonGeneGrey from '../../../../../../components/Button/ButtonGeneGrey.jsx'

export default function GetTeeth() {

const theme = useTheme();

const url_compo = `${c.API_URL}/api/mteeth`

const [compoInfo, setCompoInfo] = React.useState(null);
const [error, setError] = React.useState(null);

React.useEffect(() => {retrievePanel();}, []);

const retrievePanel = () => {
  axios
    .get(url_compo)
    .then((res) => {
      setCompoInfo(res.data);

    })
    .catch(function (error) {
      if (error.response) {
        // Request made and server responded
        setError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        setError("The request was made but no response was received.");
      } else {
        // Something happened in setting up the request that triggered an Error
        setError("Error: " + error.message);
      }
    });
};

return(
<>

{compoInfo ? 

 theme.palette.mode === "light" ? (

  <CardMarkerSmall

    headline = "TOOTH DECAY" 
    subtext = {"This section shows the dangerous part of your teeth microbiome, including detrimental bacteria species and helper bacteria genera which build the foundation of bad bacteria biofilms..​"}

    cardlines = {<>

    

      <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  bgcolor: 'grey.C100', borderRadius: '10px', border: 'groove',   }}>

{compoInfo.map((i, index) => (<>
        <Grid size={5} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard={ i.species }  /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <ButtonGeneGrey name={ i.relative_abundance } /> </Grid>   
        <Grid size={3}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = "Ref: 0" /> </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Tooth plaque and caries is mainly originated in the presence of specific streptococci bacteria." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   <TrafficLightIndicator value={i.relative_abundance} lowThreshold="0" highThreshold="0" /> </Grid> 
</>)
    
)} 

     <Grid size={12}> <Divider role="presentation" sx={{mt:2, mb:4, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

       <Grid size={12} sx={{mb:2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> <GetGenus /> </Grid>

  </Grid>   

  </>}  
/>

 ) : (

 <CardMarkerSmall

      headline = "TOOTH DECAY" 
    subtext = {"This section shows the dangerous part of your teeth microbiome, including detrimental bacteria species and helper bacteria genera which build the foundation of bad bacteria biofilms..​"}

    cardlines = {<>

      <Grid container sx={{mb:2, p:3, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',  bgcolor: 'greydark.C800', borderRadius: '10px', border: 'groove',   }}>

{compoInfo.map((i, index) => (<>
        <Grid size={5} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <TextCardBold textcard={ i.species }  /> </Grid>
        <Grid size={2}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <ButtonGeneGrey name={ i.relative_abundance } /> </Grid>   
        <Grid size={3}  sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',}}>   <TextCard textcard = "Ref: 0" /> </Grid>
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  <Box display="flex" alignItems="center"> <InfoButton tooltipText="Tooth plaque and caries is mainly originated in the presence of specific streptococci bacteria." />   </Box> </Grid> 
        <Grid size={1}  sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center',}}>   <TrafficLightIndicator value={i.relative_abundance} lowThreshold="0" highThreshold="0" /> </Grid> 
</>)
    
)} 

     <Grid size={12}> <Divider role="presentation" sx={{mt:2, mb:4, borderBottomWidth: '1px', borderBottomColor: 'common.black' }}/> </Grid>

       <Grid size={12} sx={{mb:2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}> <GetGenus /> </Grid>

  </Grid>   
 

  </>}  
/>

 )

 : 

    <Grid mt={2} mb={2} justifyContent="center" container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
        <ActionAlert
            severity="warning"
            message={"Currently no information available"}
        />
        </Grid>
    </Grid>

}

{error && (
          <Grid mt={2} mb={1} justifyContent="center" container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <ActionAlert severity="error" message={error.message} />
            </Grid>
          </Grid>
)}

</> 
)
}

